import { render, staticRenderFns } from "./tableSummary.vue?vue&type=template&id=44660298&"
import script from "./tableSummary.vue?vue&type=script&lang=js&"
export * from "./tableSummary.vue?vue&type=script&lang=js&"
import style0 from "./tableSummary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports